module.exports = __webpack_public_path__ + "static/media/stage3New.bf0ce645.png";